import React from "react";
import { useTranslation } from "react-i18next";

import { clubMemberType } from "@enums/component.enum";
import { ClubListProps } from "@models/components/auth.model";
import { applyLocalization } from "@services/common.service";

const ClubListingCard: React.FC<{
  club: ClubListProps;
  deleteMemberInfo?: (rowId: string) => Promise<void>;
}> = ({ club, deleteMemberInfo }) => {
  const { t } = useTranslation();

  const renderMemberIcons = (isMember: number | boolean) => {
    if (club?.memberType === clubMemberType.Archived || !isMember) {
      return "fg-text-secondary";
    } else {
      return "fg-text-success";
    }
  };

  const renderActiveIcons = (isActive: number) => {
    if (club?.memberType === clubMemberType.Archived) {
      return "fa-question-circle fg-text-secondary";
    } else if (isActive) {
      return "fa-circle-check fg-text-success";
    } else {
      return "fa-circle-check fg-text-secondary";
    }
  };

  const renderStatus = (status: number) => {
    if (club?.memberType === clubMemberType.Archived) {
      return (
        <p className="fg-member-listing-card-status fg-text-secondary">
          {t("notRegisteredAsMember")}
        </p>
      );
    } else if (status) {
      return (
        <p className="fg-member-listing-card-status fg-text-success">
          {t("registeredAsAMember")}
        </p>
      );
    } else {
      return (
        <p className="fg-member-listing-card-status fg-text-primary-dark">
          {t("registeredAsNonMember")}
        </p>
      );
    }
  };
  return (
    <div className="fg-member-listing-card">
      <div className="d-flex">
        <i className={`fa-solid ${renderActiveIcons(club?.isActive)}`} />
        <i
          className={`fa-solid fa-address-book ${renderMemberIcons(club?.isMember)}`}
          data-testid="member-icons"
        />
      </div>
      <div className="fg-member-listing-card-desc" data-testid="club-details">
        <p className="fg-member-listing-card-title">
          {applyLocalization(club?.title)}
        </p>
        <p>{club?.email}</p>
        {renderStatus(club.isMember ? 1 : 0)}
      </div>
      {deleteMemberInfo && (
        <button
          onClick={() =>
            deleteMemberInfo && club.rowId && deleteMemberInfo(club.rowId)
          }
          data-testid="delete-member-button"
        >
          <i className="fa-solid fa-trash fg-text-error"> </i>
        </button>
      )}
    </div>
  );
};

export default ClubListingCard;
